import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Home } from "@/pages/Home";
import { Cart } from "@/pages/Cart";
import { Admin } from "@/pages/Admin";
import { CheckoutSuccess } from "@/pages/CheckoutSuccess";
import { Maintenance } from "@/pages/Maintenance";
import { Toaster } from "@/components/ui/sonner";
import { getMaintenanceStatus } from "@/api";

const ADMIN_BYPASS_PATHS = ["/admin"];

function AppShell() {
  const location = useLocation();
  const [maintenance, setMaintenance] = useState({ enabled: false, message: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const status = await getMaintenanceStatus();
        if (!cancelled) setMaintenance(status);
      } catch (err) {
        // If status check fails, default to NOT in maintenance (fail-open).
        if (!cancelled) setMaintenance({ enabled: false, message: "" });
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    check();
    return () => { cancelled = true; };
  }, [location.pathname]);

  // Admin route is always accessible (so you can toggle maintenance off)
  const isAdminRoute = ADMIN_BYPASS_PATHS.some(p => location.pathname.startsWith(p));

  if (loading) {
    return <div className="min-h-screen bg-black" />;
  }

  if (maintenance.enabled && !isAdminRoute) {
    return <Maintenance message={maintenance.message} />;
  }

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
